import { EmployeeShopError } from 'pages/gui-defs/EmployeeShops/types/employeeShops';
import { Shop } from 'pages/gui-defs/EmployeeShops/types/shops';
import isEqual from 'lodash/isEqual';
import {
  ADD_ALL_ACCESS,
  ADD_SHOP_ACCESS,
  CLEAR_SHOP_ACCESS,
  REMOVE_SHOP_ACCESS,
  RESET_STORE,
  RESTORE_SHOPS,
  SET_CAN_CHANGE_FULL_ACCESS,
  SET_EMPLOYEE_ID,
  SET_ERROR,
  SET_IS_LOADING,
  SET_IS_PRIMARY_USER,
  SET_SHOPS,
  SET_SHOP_ACCESS,
  SET_STORE,
} from '../actions/employeeShops';

export interface EmployeeShopsState {
  canChangeFullAccess: boolean;
  employeeID: string;
  error: EmployeeShopError | undefined;
  isLoading: boolean;
  isPrimaryUser: boolean;
  shops: Shop[];
}

const initialState: EmployeeShopsState = {
  canChangeFullAccess: false,
  employeeID: '',
  error: undefined,
  isLoading: true,
  isPrimaryUser: false,
  shops: [],
};

const employeeShopsReducer = (state = initialState, action: TSFixMe) => {
  const { type, payload } = action;

  switch (type) {
    case ADD_ALL_ACCESS:
      return {
        ...state,
        shops: state.shops.map(shop => ({ ...shop, hasAccess: true })),
      };

    case ADD_SHOP_ACCESS:
      return {
        ...state,
        shops: state.shops.map(shop => (shop.id === payload ? { ...shop, hasAccess: true } : shop)),
      };

    case CLEAR_SHOP_ACCESS:
      return {
        ...state,
        shops: state.shops.map(shop => ({ ...shop, hasAccess: false })),
      };

    case REMOVE_SHOP_ACCESS:
      return {
        ...state,
        shops: state.shops.map(shop =>
          shop.id === payload ? { ...shop, hasAccess: false } : shop
        ),
      };

    case RESET_STORE:
      return initialState;

    case RESTORE_SHOPS:
      const defaultShops = state.shops.map(shop => ({ ...shop, hasAccess: shop.isDefault }));

      if (isEqual(defaultShops, state.shops)) {
        return state;
      }

      return {
        ...state,
        shops: defaultShops,
      };

    case SET_CAN_CHANGE_FULL_ACCESS: {
      return {
        ...state,
        canChangeFullAccess: payload,
      };
    }

    case SET_EMPLOYEE_ID:
      return {
        ...state,
        employeeID: payload,
      };

    case SET_ERROR:
      return {
        ...state,
        error: payload,
      };

    case SET_IS_LOADING:
      return {
        ...state,
        isLoading: payload,
      };

    case SET_IS_PRIMARY_USER:
      return {
        ...state,
        isPrimaryUser: payload,
      };

    case SET_SHOPS: {
      return {
        ...state,
        shops: payload,
      };
    }

    case SET_SHOP_ACCESS: {
      return {
        ...state,
        shops: state.shops.map(shop =>
          shop.id === payload.id ? { ...shop, hasAccess: payload.hasAccess } : shop
        ),
      };
    }

    case SET_STORE: {
      return payload;
    }

    default:
      return state;
  }
};

export default employeeShopsReducer;
